export default "__VITE_ASSET__Q3ZaP8jd__"